module.exports = __webpack_public_path__ + "media/images/childcare/cover-desktop@3x-e476562d9326a9f2aed4fbf76677c73c.jpg";